module.exports = __webpack_public_path__ + "img/custom-documents.dca8ab7d.svg";